import React, { Component } from 'react';
import './Menu.js.css';

export class Menu extends Component {
    render() {
        const { menus } = this.props;
        const compo = window.location.search;

        return (
            <div className='menu'>
                <ul>
                    {menus.map(menu => {
                        return <li key={menu.nom}><a href={menu.url + compo} target='_blank' rel='noopener noreferrer' >{menu.nom}</a></li>
                    })}
                </ul>
            </div>
        );
    }
}
